import { Box, VStack, HStack, Text, IconButton, Spinner } from '@chakra-ui/react'
import { useDocuments } from '../hooks/useDocuments'
import FileUpload from './FileUpload'

export default function DocumentList() {
  const { documents, isLoading, deleteDocument, isDeleting } = useDocuments()

  return (
    <VStack p={4} gap={4} align="stretch">
      <Text fontWeight="bold" fontSize="lg" color="gray.700">
        Documents
      </Text>

      <FileUpload />

      {isLoading ? (
        <Box py={4} textAlign="center">
          <Spinner size="sm" />
        </Box>
      ) : documents.length === 0 ? (
        <Text color="gray.500" fontSize="sm" textAlign="center" py={4}>
          No documents yet. Upload a PDF to get started.
        </Text>
      ) : (
        <VStack gap={2} align="stretch">
          {documents.map((doc) => (
            <HStack
              key={doc.id}
              p={3}
              bg="gray.50"
              borderRadius="md"
              justifyContent="space-between"
              _hover={{ bg: 'gray.100' }}
            >
              <VStack align="start" gap={0} flex={1} minW={0} overflow="hidden">
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                  truncate
                  maxW="100%"
                  title={doc.name}
                  color={doc.status === 'ready' ? 'gray.800' : doc.status === 'processing' ? 'gray.400' : 'red.500'}
                >
                  {doc.name}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {doc.status === 'processing' ? 'Processing...' : doc.pageCount ? `${doc.pageCount} pages` : 'Ready'}
                </Text>
              </VStack>
              <IconButton
                aria-label="Delete document"
                size="sm"
                variant="ghost"
                colorScheme="red"
                loading={isDeleting === doc.id}
                onClick={() => deleteDocument(doc.id)}
              >
                <TrashIcon />
              </IconButton>
            </HStack>
          ))}
        </VStack>
      )}
    </VStack>
  )
}

function TrashIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z" />
    </svg>
  )
}
